const weight_type = 'lb';

const mutation = key => (state, value) =>
{
  state[key] = value;
};

const weight_type_update = mutation('weight_type');

export default
{
  state: () =>
  ({
    weight_type,
  }),
  mutations:
  {
    weight_type_update,
  },
};